import { Component, inject, OnInit } from '@angular/core'
import { NavigationStart, Router, RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { filter } from 'rxjs'
import { resetEmployeeState } from './store/user/user.actions'
import { resetBusinessState } from './store/business/business.actions'
import { resetDepartmentState } from './store/department/department.actions'
import { resetDesignationState } from './store/designation/designation.actions'
import { FirebaseService } from './services/firebase.service'
import { PushNotificationService } from './services/push-notification.service'
import { Title } from '@angular/platform-browser'
import { environment } from '../environments/environment'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'AVR HRMS'

  private router = inject(Router)
  private store = inject(Store)

  constructor(
    private firebaseService: FirebaseService,
    private pushService: PushNotificationService,
    private titleService: Title,
    private modalService: NgbModal
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      // Dispatch your reset actions here
      this.store.dispatch(resetBusinessState())
      this.store.dispatch(resetEmployeeState())
      this.store.dispatch(resetDepartmentState())
      this.store.dispatch(resetDesignationState())
      this.firebaseService.requestPermission()
      this.firebaseService.listenForMessages()
      this.titleService.setTitle(environment.title)
      // Add more resets if needed: this.store.dispatch(resetEmployeeState());
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.modalService.dismissAll()
        }
      })
    })
  }

  ngOnInit() {
    this.firebaseService.requestPermission().then(token => {
      if (token) {
        // Send FCM token to backend here
        console.log('FCM Token app component:', token)
      }
    })

    this.firebaseService.listenForMessages()
    this.requestNotificationPermission()
  }

  requestNotificationPermission() {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        console.log('Notification permission granted.')
        this.pushService.requestSubscription()
      } else {
        console.warn('Notification permission denied.')
      }
    })
  }
}
